import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LoginForm from "../components/loginForm";

const Login = () => {
  const { test_id } = useParams();

  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-md-6 text-center text-md-start px-5">
          <h1 className="fw-bold text-grey">
            Login Now
            <br />
            <span className="text-warning">To Access Your Test</span>
          </h1>
        </div>

        <LoginForm test_id={test_id}/>
      </div>
    </div>
  );
};

export default Login;
